$shm_hitalama_opencode_map_widget_session $shm_hitalama_opencode_session
	widget $shm_hitalama_map_widget
	Map_page $shm_hitalama_map_page
	Map_sessions $shm_hitalama_opencode_map_sessions
		server_url <= server_url
		map_id <= map_id \
		session_id? <=> session_id? \
		new_session_model <= new_session_model null
	auto /
		<= events_native null
